import { Dispatch, useReducer } from 'react';

type IInitializerArgs<S> = Partial<S> | (() => Partial<S>);

/**
 * A pure alternative to useState.
 *
 * Calling setState with any object will update just the passed fields and leave the previous state as it is.
 *
 * @param initializerArg - The initial state,
 */
export default function usePureState<S>(initializerArg: IInitializerArgs<S>) {
  const [state, dispatch] = useReducer(pureReducer, initializerArg);

  // React has this typed as has "any" so we cast to a subset of the state.
  return { state, setPartialState: dispatch } as { state: S; setPartialState: Dispatch<Partial<S>> };
}

function pureReducer<S>(state: S, action: Partial<S>) {
  return { ...state, ...action };
}
